import _extends from 'babel-runtime/helpers/extends';
import _classCallCheck from 'babel-runtime/helpers/classCallCheck';

var Observer = function Observer() {
  var _this = this;

  _classCallCheck(this, Observer);

  Object.defineProperty(this, 'findListenerByPath', {
    enumerable: true,
    writable: true,
    value: function value(path) {
      for (var i = 0, l = _this.listeners.length; i < l; ++i) {
        if (_this.listeners[i].path === path) {
          return _this.listeners[i];
        }
      }
      return null;
    }
  });
  Object.defineProperty(this, 'when', {
    enumerable: true,
    writable: true,
    value: function value(path, then) {
      /* stop if the DOM element is already listened */
      if (_this.findListenerByPath(path)) {
        return;
      }
      if (typeof then === 'function') {
        then = { isCreated: then };
      }
      /* add the listener */
      _this.listeners.push(_extends({
        path: path
      }, then));
      _this.handleListener(_this.listeners[_this.listeners.length - 1]);
    }
  });
  Object.defineProperty(this, 'onChange', {
    enumerable: true,
    writable: true,
    value: function value(mutations) {
      for (var i = 0, l = _this.listeners.length; i < l; ++i) {
        _this.handleListener(_this.listeners[i]);
      }
    }
  });
  Object.defineProperty(this, 'isReady', {
    enumerable: true,
    writable: true,
    value: function value(path) {
      try {
        return document.querySelector(path);
      } catch (err) {
        console.error(err);
        return false;
      }
    }
  });
  Object.defineProperty(this, 'disconnect', {
    enumerable: true,
    writable: true,
    value: function value() {
      if (_this.observer && _this.observer.disconnect) {
        _this.observer.disconnect();
      }
    }
  });
  Object.defineProperty(this, 'handleListener', {
    enumerable: true,
    writable: true,
    value: function value(listener) {
      /* if DOM element existed before and disappeared */
      if (!_this.isReady(listener.path)) {
        if (listener.exists) {
          listener.exists = false;
          if (listener.isRemoved) {
            listener.isRemoved();
          }
        }
        return;
      }

      /* if DOM element appeared */
      if (!listener.exists && listener.isCreated) {
        listener.exists = true;
        listener.isCreated();
      }
    }
  });

  this.listeners = [];
  this.observer = new MutationObserver(this.onChange);
  this.observer.observe(document.body, {
    childList: true,
    subtree: true,
    attributes: false,
    characterData: false
  });
};

export default Observer;
//# sourceMappingURL=observer.js.map


//////////////////
// WEBPACK FOOTER
// ../gipsy-misc/lib/utils/observer.js
// module id = 406
// module chunks = 0